import dropdown from '#utilities/js/lightboxes/menus/dropdown.js'
import * as utilities from '#utilities/js/styles.js'
import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

export default list => {
  const { ownerDocument } = list
  const container = one(`.${utilities.elements.aside_lightboxes}`, ownerDocument)

  queueMicrotask(() => inserted(list, container).then(dropdown))
}